import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import DoctorsFilterOptions from "../../../../components/Common/CommonFilterOptions";
import NavBarTitles from "../../../../components/Common/TabBar";
import Deletepopup from "../../../../components/Modal/Deletepopup";
import { DocterBreadcrumbs, DocternavBarData } from "../../Utils/MasterConst";

// Updated custom hook paths
import Actions from "../../../../components/Common/Actions";
import FilledButton from "../../../../components/Common/Buttons/FilledButton";
import ListPageLayout from "../../../../components/Layout";
import useDebouncedSearch from "../../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../../components/Utils/hooks/useSortHandler";

const UGDegree = () => {
  const navigate = useNavigate();

  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);
  const [loader, setLoader] = useState(true);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  const addNewUgDegree = {
    id: "addnewpost",
    onClick: () => navigate("/master-ug-course-create"),
    className: "addnewhealth",
    style: { width: "240px" },
    label: "Add New Ug Degree",
  };

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}ug-degree/list`,
      initialParams: {
        sort,
        searchText: search,
        noLimit: true,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler("ug-degree", fetchData, setShowDelete);

  useEffect(() => {
    setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search]);

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    {
      title: "UG Degree",
      dataIndex: "ug_degree",
      key: "ug_degree",
      width: 200,
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      render: (active) => (active ? "Verified" : "Not Verified"),
      width: 150,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <Actions
            isEdit={true}
            isDelete={true}
            isView={true}
            onClickView={() => navigate(`/master-ug-course-view/${record._id}`)}
            onClickDelete={() => {
              setDeleteId(record._id);
              setShowDelete(true);
            }}
            onClickEdit={() => navigate(`/master-ug-course-edit/${record._id}`)}
          />
        </div>
      ),
    },
  ];

  const dataSource = records.map((el) => ({ ...el, key: el._id }));

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);
  return (
    <ListPageLayout
      breadcrumbs={<DocterBreadcrumbs last="UG Degree" />}
      addButton={<FilledButton props={addNewUgDegree} />}
      titles={<NavBarTitles titles={DocternavBarData} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}
    </ListPageLayout>
  );
};

export default UGDegree;
